import { TipoRetorno } from "../components/ModalRetorno";
import { chaveStatusAutorizacao } from "../constants/status";
import { IResultadoReprocessamento } from "../interfaces/IAcoesLote";
import { IItemLote } from "../interfaces/IItemLote";

export function emFalha({
  statusAutorizacao,
}: Pick<IItemLote, "statusAutorizacao">): boolean {
  return chaveStatusAutorizacao(statusAutorizacao) === "FALHA";
}

export function elegivelParaReprocessar(
  item: Pick<IItemLote, "statusAutorizacao" | "idAutorizacao">
): boolean {
  return emFalha(item) && !item.idAutorizacao?.trim();
}

// sem seleção vale a página: lista vazia faria o ms_aw reprocessar o lote inteiro
export function idsParaReprocessar(
  selecionados: IItemLote[],
  itensDaPagina: IItemLote[]
): number[] {
  const alvo = selecionados.length ? selecionados : itensDaPagina;
  return alvo.filter(elegivelParaReprocessar).map(({ id }) => id);
}

export function retornoReprocessamento({
  enviadas,
  naoEnviadas,
  falhasEnvio,
  ignoradas,
}: IResultadoReprocessamento): { mensagem: string; tipo: TipoRetorno } {
  const total = enviadas + naoEnviadas + falhasEnvio + ignoradas;

  if (!enviadas) {
    return { mensagem: "Não foi possível Reprocessar.", tipo: "erro" };
  }

  if (enviadas < total) {
    return {
      mensagem: `${enviadas} de ${total} placas reenviadas ao miner.`,
      tipo: "aviso",
    };
  }

  return {
    mensagem: "As solicitações com status de erro serão reprocessadas.",
    tipo: "sucesso",
  };
}
